import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=26405c88&scoped=true"
import script from "./UpdatePassword.js?vue&type=script&lang=js&external"
export * from "./UpdatePassword.js?vue&type=script&lang=js&external"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=26405c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26405c88",
  null
  
)

export default component.exports